module.exports = __webpack_public_path__ + "static/media/icon-denied-circular.0d0e60cf.svg";